import maltahomesearch from "../../img/maltahomesearch.PNG";
import samoshibtokenflip from "../../img/samoshibtokenflip.PNG";
import samoshibwebsite from "../../img/samoshibwebsite.PNG";
import bole from "../../img/bole.PNG";
import maxercoin from "../../img/maxercoin.PNG";
import kimusic from "../../img/kimusic.png";

export default [
  {
    image: maltahomesearch,
    name: "Real Estate",
    description: "A property listing platform for finding homes in Malta with advanced search and filtering.",
    tags: ["React", "Node.js", "MongoDB"],
    link: "https://maltahomesearch.vercel.app/",
  },
  {
    image: samoshibwebsite,
    name: "Samoshib Website",
    description: "Official landing page for the Samoshib token ecosystem with live stats and community features.",
    tags: ["React", "Web3", "Solidity"],
    link: "https://samoshib.com/",
  },
  {
    image: maxercoin,
    name: "Web3 Investment Platform",
    description: "A decentralized investment platform enabling users to stake, earn, and manage crypto assets.",
    tags: ["React", "Blockchain", "DeFi"],
    link: "https://maxercoin.com/",
  },
  {
    image: samoshibtokenflip,
    name: "Token Flip Game",
    description: "An interactive blockchain-based coin flip game with on-chain randomness and rewards.",
    tags: ["React", "Smart Contracts", "Gaming"],
    link: "https://tokenflip.samoshib.com/",
  },
  {
    image: bole,
    name: "Bole Token Website",
    description: "Marketing and information website for Bole Token with tokenomics and roadmap.",
    tags: ["React", "Web3", "CSS"],
    link: "https://newboletoken.com/",
  },
  {
    image: kimusic,
    name: "Music Player Website",
    description: "A sleek music streaming web app with playlist management and audio visualization.",
    tags: ["React", "API", "CSS"],
    link: "https://kimusic.vercel.app",
  },
];
